if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

if (!customElements.get('quick-add-variations')) {
  customElements.define(
    'quick-add-variations',
    class QuickAddVariations extends HTMLElement {
      constructor() {
        super();

        // Mobile/tablet (no hover pointer): use fixed panel behavior + add a close button
        if (window.matchMedia('(max-width: 1365px)').matches) {
          this.classList.add('quick-add-variations--fixed');
          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'quick-add-variations__close';
          closeBtn.innerHTML = '&times;';
          closeBtn.addEventListener('click', () => {
            this.style.display = 'none';
            document.body.classList.remove('quick-add-open');
          });
          this.appendChild(closeBtn);
        }
        // END fixed panel behavior for touch devices

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const oButtons = $(this).children('button.option');
        const sButton = $(this).children('button.quick-add__submit');
        const popupCartErr = document.querySelector('#cart-popup');

        // Bind the global click handler only once (event delegation)
        if (!window.__qavBoundOnce) {
          window.__qavBoundOnce = true;

          document.addEventListener('click', function (e) {
            // SHOW: clicked on a trigger button
            const btn = e.target.closest('button[data-trigger-variations]');
            if (btn) {
              // Ignore slick cloned slides
              if (btn.closest('.slick-cloned')) return;

              // Stop other handlers so this doesn't get canceled by other listeners
              if (e.stopImmediatePropagation) e.stopImmediatePropagation();
              e.stopPropagation();
              e.preventDefault();

              const pid = btn.getAttribute('data-trigger-variations');
              // Prefer section id from the button; fallback to nearest wrapper with data-section-id
              const sectionId =
                btn.getAttribute('data-section-id') ||
                (btn.closest('[data-section-id]') && btn.closest('[data-section-id]').getAttribute('data-section-id'));

              // Match panel by productId + sectionId to avoid collisions across sections
              const panelSelector = sectionId
                ? `quick-add-variations[data-product-id="${pid}"][data-section-id="${sectionId}"]`
                : `quick-add-variations[data-product-id="${pid}"]`;

              const panel = document.querySelector(panelSelector);

              if (!panel) {
                console.warn('[QAV] Panel not found for', { pid, sectionId });
                return;
              }

              // Move panel to <body> to avoid stacking/overflow issues
              document.body.appendChild(panel);

              // Hide all other panels before showing current
              document.querySelectorAll('quick-add-variations').forEach(el => (el.style.display = 'none'));

              // Show current panel
              panel.style.display = 'flex';
              document.body.classList.add('quick-add-open');
              return;
            }

            // HIDE: clicked outside any panel and not on a trigger
            const insidePanel = e.target.closest('quick-add-variations');
            const isTrigger = e.target.closest('button[data-trigger-variations]');
            if (insidePanel || isTrigger) return;

            document.querySelectorAll('quick-add-variations').forEach(el => (el.style.display = 'none'));
            document.body.classList.remove('quick-add-open');
          });
        }

        // Add to cart via size option buttons
        oButtons.on('click', event => {
          event.stopPropagation();
          sButton.addClass('button-adding');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const ele = event.target;
          const variantId = ele.getAttribute('data-variant-id');

          const formData = new FormData();
          formData.append('id', variantId);

          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                // Surface error and close the panel
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message
                });
                this.style.display = 'none';
                document.body.classList.remove('quick-add-open');
                sButton.removeClass('button-adding');

                // Show small popup error on mobile
                popupCartErr.querySelector('p').innerHTML = response.message;
                popupCartErr.style.display = 'block';
                setTimeout(() => (popupCartErr.style.display = 'none'), 3000);

                return;
              } else if (!this.cart) {
                // No cart drawer/notification → fallback to cart page
                window.location = window.routes.cart_url;
                return;
              }

              // Success: update cart sections and close the panel
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response
              });
              this.cart.renderContents(response);
              this.style.display = 'none';
              document.body.classList.remove('quick-add-open');
              sButton.removeClass('button-adding');
              console.log('269');
            })
            .catch(error => {
                console.log('[QAV] cart_add error', error);
                this.style.display = 'none';
                document.body.classList.remove('quick-add-open');
                sButton.removeClass('button-adding');
                console.log('276');
            })
            .finally(() => {
              this.cart && this.cart.classList.contains('is-empty') && this.cart.classList.remove('is-empty');
              console.log('279');
            });
        });
      }
    }
  );
}

